import MiClock from './clock';
import { install } from '../../utils/install';
export default install(MiClock);
